module.exports = "https://www.gc-qa.gnp.com.mx/03d6992ee2d3c5ae95e5eb8104d85f69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-information.svg
// module id = 8123
// module chunks = 0